"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M12 8.6 9.07 13h5.86z",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M5 17h14v2H5zm7-12L5.33 15h13.34zm0 3.6 2.93 4.4H9.07z"
}, "1")], 'EjectTwoTone');